import styled from 'styled-components';
import svg from '../../../static/img/check-icon-branco.svg';

export const CheckboxContainer = styled.div`
  position: relative;
  margin-right: 8px;
  > input {
    padding: 0;
    margin: 0;
    opacity: 0;
    top: 0;
    left: 0;
    width: 18px;
    height: 18px;
    position: absolute;
  }

  > input:focus ~ span {
    outline: 2px dotted #0669de;
    outline-offset: 3px;
  }

  > input:checked ~ span {
    background-color: #0669de;
  }

  > span {
    display: inline-block;
    text-align: center;
    line-height: 0.8;
    border: 0.06125rem solid black;
    width: 18px;
    height: 18px;
    border-radius: 3px;
    padding: 0 1.5px;
    box-sizing: border-box;
    background: #fff url(${svg}) no-repeat center center;
    background-size: 99%;
    transition: background-color 0.2s ease;
  }
  > input:checked ~ span {
    border: 0.06125rem solid #0669de;
  }
`;
